import { ServiceInvoiceMatrixBase } from './service-invoice-matrix-base';
import { I18N } from 'aurelia-i18n';
import { autoinject, bindable } from 'aurelia-framework';
import { ErpSystemService, ServiceWashProductMatrixService } from 'services';
import { ToastService } from 'services/toast-service';
import { ErrorService } from 'services/error-service';

@autoinject
export class WashMatrixView extends ServiceInvoiceMatrixBase {
  @bindable
  protected erpSystemId: number;

  constructor(
    t: I18N,
    matrixService: ServiceWashProductMatrixService,
    toaster: ToastService,
    errorService: ErrorService,
    erpSystemService: ErpSystemService
  ) {
    super(t, matrixService, toaster, errorService, erpSystemService);
    this.setErpSystemId(this.erpSystemId);
  }
}
